import { getFallbackData } from './billConfig';

interface BillRouteSource {
  route: string;
  pageTitle: string;
}

const normalizeTitle = (title: string): string => title.trim().toLowerCase();

const createLegacyBillSlug = (billTitle: string): string =>
  billTitle
    .toLowerCase()
    .replace(/^the\s+/i, '')
    .replace(/\s+(and|or|of|for)\s+/gi, '-')
    .replace(/integrety/g, 'integrity')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');

export const resolveBillRoute = (billTitle: string, billPages: ReadonlyArray<BillRouteSource> | undefined): string => {
  const normalizedTitle = normalizeTitle(billTitle);
  const canonicalBill = [...(billPages || []), ...getFallbackData()].find(
    (billPage) => normalizeTitle(billPage.pageTitle) === normalizedTitle,
  );

  return canonicalBill?.route || createLegacyBillSlug(billTitle);
};
